import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'

const module = 'interventiontypes'
let doc = {
  list: {
    name: 'Interventions',
    headers: [
      { label: 'Nom', value: 'name' },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['interventiontypes.create'], dispatch: `${module}/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['interventiontypes.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
    ],
    search: [
      { label: 'Nom', type: 'text', name: 'name' },
    ],
  },

  form: {
    name: "Type d'intervention",
    fields: [
      { label: 'Titre', name: 'name', type: 'text', hint: "Comment vous souhaitez nommer ce type d'intervention" },
    ],
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['interventiontypes.update'], dispatch: `${module}/update` },
      {
        icon: 'delete',
        isFlat: true,
        scope: ['interventiontypes.delete'],
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
    ],

  },

  params: {
    fetchAll: {},
    fetchOne: {},
  },
}

export default crudmaker(module, apiClient, doc)
